import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { ContentTypeFieldResponse } from '../../../../../Model/responseDtos/ContentTypeFieldResponse';
import { RemoveCell } from '../../../../grid/customCells/RemoveCell';
import { CustomFieldCell } from '../CustomFieldCell';

enum GridFileFields {
  METADATA_PREFIX = 'perFileMetadata.'
}

export const NameCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  const file = dataItem?.file || dataItem;
  return <td title={file?.name}>{file?.name}</td>;
};

interface CellHandlers {
  getFieldChoices: (field: any) => any[];
  perFileFields: ContentTypeFieldResponse[];
  handleRemove: (fileIndex: number) => void;
}

export const createRemoveCellWrapper = (handlersRef: React.RefObject<CellHandlers>) => {
  return React.memo((props: GridCellProps) => {
    return <RemoveCell {...props} onClick={() => handlersRef.current.handleRemove(props.dataIndex)} />;
  });
};

export const createCustomFieldCellWrapper = (handlersRef: React.RefObject<CellHandlers>) => {
  return React.memo((props: GridCellProps) => {
    const { field } = props;

    if (!field || !field.startsWith(GridFileFields.METADATA_PREFIX)) {
      return <td />;
    }

    const fieldName = field.replace(GridFileFields.METADATA_PREFIX, '');
    const ctField = handlersRef.current.perFileFields.find(f => f.name === fieldName);

    if (!ctField) {
      return <td>Field not found</td>;
    }

    return (
      <td>
        <CustomFieldCell {...props} ctField={ctField} getFieldChoices={handlersRef.current.getFieldChoices} />
      </td>
    );
  });
};
